import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["advancedDescription", "modeText"]

  connect() {
    this.updateMode()
  }

  toggleMode(event) {
    this.updateMode()
  }

  updateMode() {
    const isAdvanced = this.element.querySelector('input[name="advanced"]:checked')?.value === "true"
    
    if (isAdvanced) {
      this.advancedDescriptionTarget.classList.remove("hidden")
      this.modeTextTarget.textContent = "completely custom CSS and layouts"
    } else {
      this.advancedDescriptionTarget.classList.add("hidden")
      this.modeTextTarget.textContent = "colors, fonts, and layout"
    }
  }
}